import {
  GET_OVERTIME_MY_REQUESTS_ERROR,
  GET_OVERTIME_MY_REQUESTS_PENDING,
  GET_OVERTIME_MY_REQUESTS_SUCCESS,
  GET_TIME_ADJUSTMENT_MY_REQUESTS_ERROR,
  GET_TIME_ADJUSTMENT_MY_REQUESTS_PENDING,
  GET_TIME_ADJUSTMENT_MY_REQUESTS_SUCCESS,
  SET_OVERTIME_MY_REQUESTS,
  SET_TIME_ADJUSTMENT_MY_REQUESTS,
} from './constants';

const INIT_STATE = {
  overTimeMyRequests: [],
  timeAdjustmentMyRequests: [],
  isGetOverTimeMyRequests: false,
  isGetTimeAdjustmentMyRequests: false,
};

export default (localState = INIT_STATE, action) => {
  switch (action.type) {
    case GET_OVERTIME_MY_REQUESTS_PENDING: {
      return {
        ...localState,
        isGetOverTimeMyRequests: true,
      };
    }
    case GET_OVERTIME_MY_REQUESTS_SUCCESS: {
      return {
        ...localState,
        isGetOverTimeMyRequests: false,
      };
    }
    case GET_OVERTIME_MY_REQUESTS_ERROR: {
      return {
        ...localState,
        isGetOverTimeMyRequests: false,
      };
    }
    case SET_OVERTIME_MY_REQUESTS: {
      return {
        ...localState,
        overTimeMyRequests: action.payload,
      };
    }
    case GET_TIME_ADJUSTMENT_MY_REQUESTS_PENDING: {
      return {
        ...localState,
        isGetTimeAdjustmentMyRequests: true,
      };
    }
    case GET_TIME_ADJUSTMENT_MY_REQUESTS_SUCCESS: {
      return {
        ...localState,
        isGetTimeAdjustmentMyRequests: false,
      };
    }
    case GET_TIME_ADJUSTMENT_MY_REQUESTS_ERROR: {
      return {
        ...localState,
        isGetTimeAdjustmentMyRequests: false,
      };
    }
    case SET_TIME_ADJUSTMENT_MY_REQUESTS: {
      return {
        ...localState,
        timeAdjustmentMyRequests: action.payload,
      };
    }
    default:
      return { ...localState };
  }
};
